<template>
  <button
    type="submit"
    class="--large"
    :class="{ '--dark': color === 'dark', '--white': color === 'white' }"
  >
    <span class="btn__stroke"></span>
    <span class="btn__label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "dark"
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  border: none;
  font-family: "Gilam SemiBold";
  // @include fontSizes(15px, 12px, 13px, 15px, 15px);
  font-size: 15px;
  background-color: #272727;
  // color: #fff;
  width: 240px;
  color: $black;
  padding-left: 0;
  height: 50px;
  display: inline-flex;
  text-transform: uppercase;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1;
    width: 9px;
    height: 100%;
    background-color: $yellow;
    opacity: 1;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #272727;
    &::after {
      width: 100%;
    }

    .btn__label {
      transform: translateX(20px);
    }

    .btn__stroke {
      width: 20px;
    }
  }

  .btn__label {
    line-height: 1;
    padding-left: 30px;
    margin-right: 65px;
    white-space: nowrap;
    display: inline-block;
    transition: transform 0.3s ease;
  }

  .btn__stroke {
    position: absolute;
    left: 20px;
    width: 0;
    height: 1px;
    background-color: $dark-grey;
    transition: width 0.3s ease;
  }

  &.--white {
    color: $black;
    background-color: $white;

    &:hover {
      color: $black;
    }
    &::after {
      background-color: $yellow;
    }
  }

  &.--dark {
    color: $white;
  }
}

@media screen and (min-width: $screen-sm) {
  button {
    .btn__label {
      margin-right: 30px;
    }
  }
}
</style>
